import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "ML and DL Enthusiast",
          "Web Developer{MERN}",
          "AI Enthusiast",
          "IoT Innovate",
          "Cyber Security Aspirant"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
